import { useMemo } from 'react';
import { useCreateEvaluationGradeEntryBase } from '../../../Loaders/CreateEvaluationGradeEntryBaseLoader';
import { DeliveryModes } from '../../../types';

const useOnlineDeliveryModeToStructureView = () => {
  const { data } = useCreateEvaluationGradeEntryBase();
  const deliveryMode = data?.sectionData?.StructureTypeSchema_deliveryMode;

  const isOnlineDeliveryMode = useMemo(() => {
    return (
      !!deliveryMode &&
      [DeliveryModes.OL, DeliveryModes.SP, DeliveryModes.OA].includes(
        deliveryMode as DeliveryModes,
      )
    );
  }, [deliveryMode]);

  return {
    isOnlineDeliveryMode,
  };
};

export default useOnlineDeliveryModeToStructureView;
